/** @format */

import { GiftCard } from './giftcard.interface';

export interface CheckoutPayment {
  gift_cards?: GiftCard[];
  payment_processor?: {
    external_key?: string;
    payer_authentication?: any;
    payment_type?: string;
    processor?: string;
    saved_payment_indicator?: string;
  };
  resiliency?: boolean;
}
